/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 14:08:11
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-20 18:12:02
 */
import { Col, Form, Input, Modal, Row, Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { RootDispatch } from '../../../../app/store'
import { DurgSaveform } from '../../../commoditySave/Durgsaveform'
import { MaterialSaveform } from '../../../commoditySave/Materialssaveform'
import styles from './RecipeItemInput.module.css'
import { ApparatusSaveform } from '../../../commoditySave/ApparatusSaveform'
import { NondurgSaveform } from '../../../commoditySave/Nondurgsaveform'
import { selectSettings } from '../../../user/setting/settingSlice'
import { Checks } from '../../../../models/setting'
import { NewDurgSaveform } from '../../../commoditySave/NewDurgsaveform'
import { NewMaterialsSaveform } from '../../../commoditySave/NewMaterialssaveform'
import { NewApparatusSaveform } from '../../../commoditySave/NewApparatusSaveform'
import { NewNondurgSaveform } from '../../../commoditySave/NewNondurgsaveform'

const { Option } = Select

export const AddCatalogueModal = (props: {
  isModalVisible: boolean
  medicalType?: any
  details?: any
  onOk: () => void
  onCancel: () => void
  batch?: (v?: any) => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()
  
   const settings  = useSelector(selectSettings)

  const DurgSaveforms = settings?.[Checks.MLKG] == 1 ? NewDurgSaveform : DurgSaveform

  const MaterialSaveforms = settings?.[Checks.MLKG] == 1 ? NewMaterialsSaveform : MaterialSaveform

  const ApparatusSaveforms = settings?.[Checks.MLKG] == 1 ? NewApparatusSaveform : ApparatusSaveform

  const NondurgSaveforms = settings?.[Checks.MLKG] == 1 ? NewNondurgSaveform : NondurgSaveform

  return (
    <Modal
      className={styles.modal}
      width={1850}
      title='新增目录'
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      centered
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      {/* 1:药品 2:诊疗 3:耗材/材料	 */}
      {props?.medicalType == 0 ? (
        <DurgSaveforms
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        />
      ) : props?.medicalType == 1 ? (
        <MaterialSaveforms
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        />
      ) : props?.medicalType == 2 ? (
        <ApparatusSaveforms
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        />
      ) : props?.medicalType == 4 ? (
        <NondurgSaveforms
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v?: any) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        />
      ) : (
        <></>
      )}
    </Modal>
  )
}
